<form *ngIf="form" [formGroup]="form">
    <h4 class="bk-modal__section-title">
        {{'Calculate Manure N Credits' | translate }}
    </h4>

    <div class="bk-modal__section-subtitle">
        {{ 'Prior Year' | translate }}
    </div>

    <mat-form-field  appearance="fill"
        class="mat-form-field--one-line mat-form-field--short">

        <mat-label>
            {{'Manure Type' | translate }}
        </mat-label>

        <mat-select required
            name="TypePriorYear"
            formControlName="TypePriorYear">

            <mat-option *ngFor="let manureTypeOption of manureTypeOptions"
                [value]="manureTypeOption.keys[0]">
                {{manureTypeOption.label}}
            </mat-option>

        </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill">
        <mat-label>
            {{'Manure Rate' | translate }}
        </mat-label>
        <input matInput
            type="number"
            required
            name="manureRatePriorYear"
            formControlName="RatePriorYear" />
        <span matSuffix class="mat-form-field-suffix--padded">
            {{'tons' | translate }} /{{'acre' | translate }}
        </span>
    </mat-form-field>

    <div class="bk-modal__section-subtitle">
        {{ '2 Years Ago' | translate }}
    </div>

    <mat-form-field  appearance="fill"
        class="mat-form-field--one-line mat-form-field--short">

        <mat-label>
            {{'Manure Type' | translate }}
        </mat-label>

        <mat-select required
            name="manureTypeTwoYearsAgo"
            formControlName="TypeTwoYearsAgo">

            <mat-option *ngFor="let manureTypeOption of manureTypeOptions"
                [value]="manureTypeOption.keys[1]">
                {{manureTypeOption.label}}
            </mat-option>

        </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill">
        <mat-label>
            {{'Manure Rate' | translate }}
        </mat-label>
        <input matInput
            type="number"
            required
            name="manureRateTwoYearsAgo"
            formControlName="RateTwoYearsAgo" />
        <span matSuffix class="mat-form-field-suffix--padded">
            {{'tons' | translate }} /{{'acre' | translate }}
        </span>
    </mat-form-field>

    <!-- footer -->
    <div class="bk-modal__section-buttons">
        <button class="bk-button bk-button--medium bk-button--text-only"
            (click)="cancel($event)">
            {{'Cancel' | translate }}
        </button>
        <button class="bk-button bk-button--medium"
            [disabled]='form.invalid'
            (click)="calculate($event)">
            {{'Calculate' | translate }}
        </button>
    </div>
</form>